import { render, staticRenderFns } from "./ThreadClip.vue?vue&type=template&id=9a86c738&scoped=true"
import script from "./ThreadClip.vue?vue&type=script&lang=js"
export * from "./ThreadClip.vue?vue&type=script&lang=js"
import style0 from "./ThreadClip.vue?vue&type=style&index=0&id=9a86c738&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a86c738",
  null
  
)

export default component.exports